'use client';

import { Button } from '@mui/material';
import { usePageAction } from '@repo/hooks/usePageAction';
import { LinkViewed } from '@repo/segment/Analytics/LinkViewed';

type Props = {
  reviewLink?: string;
  institution?: {
    id: string;
    name?: string;
  };
  linkPosition?: number;
};

export const ReviewButton = ({ reviewLink, institution, linkPosition }: Props) => {
  // TODO: Segment Standardization Cleanup
  const readReviewButtonClickEvent = usePageAction({
    actionDestinationUrl: reviewLink,
    actionName: 'nw_review_redirected',
    actionSection: 'banking_cd_institution_card',
    actionType: 'select',
    additionalAttributes: {
      institution_id: institution?.id,
      institution_nm: institution?.name,
    },
  });

  if (!reviewLink) return null;

  return (
    <LinkViewed
      entityName="nw_review_redirected"
      sectionName="banking_cd_institution_card"
      destinationUrl={reviewLink}
      linkCopy="Read Review"
      linkPosition={linkPosition}
      pageType="roundup"
      additionalAttributes={{
        institution_id: institution?.id,
        institution_nm: institution?.name,
      }}
    >
      {({ fireLinkClicked }) => (
        <Button
          fullWidth
          sx={{ textWrap: 'nowrap', minWidth: '130px' }}
          href={reviewLink}
          target="_blank"
          onClick={() => {
            readReviewButtonClickEvent();
            fireLinkClicked();
          }}
        >
          Read Review
        </Button>
      )}
    </LinkViewed>
  );
};
